module.exports = __webpack_public_path__ + "static/media/ss-shopify-demo.343c8804.png";